import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "/",
        name: "index",
        meta: {
          title: "主页",
        },
        component: () => import("../views/home/index.vue"),
      },
      {
        name: "aboutUs",
        meta: {
          title: "关于我们",
        },
        path: "/aboutUs",
        component: () => import("../views/aboutUs/companyIntroduction.vue"),
        children: [
          {
            name: "companyIntroduction",
            path: "/companyIntroduction",
            component: () => import("../views/aboutUs/companyIntroduction.vue"),
            meta: {
              title: "公司介绍",
            },
          },
          {
            name: "serviceAdvantages",
            path: "/serviceAdvantages",
            component: () => import("../views/aboutUs/companyIntroduction.vue"),
            meta: {
              title: "业务优势介绍",
            },
          },
          {
            name: "developmentHistory",
            path: "/developmentHistory",
            component: () => import("../views/aboutUs/companyIntroduction.vue"),
            meta: {
              title: "发展历程",
            },
          },
        ],
      },
      {
        path: "/productIntroduction",
        name: "productIntroduction",
        component: () =>
          import("../views/productIntroduction/productPresentation.vue"),
        meta: {
          title: "产品介绍",
        },
        children: [
          {
            path: "/relatedDiseases",
            name: "relatedDiseases",
            component: () =>
              import("../views/productIntroduction/productPresentation.vue"),
            meta: {
              title: "相关疾病",
            },
          },
          {
            path: "/productPresentation",
            name: "productPresentation",
            component: () =>
              import("../views/productIntroduction/productPresentation.vue"),
            meta: {
              title: "产品介绍",
            },
          },
        ],
      },
      {
        path: "/newsInformation",
        name: "newsInformation",
        meta: {
          title: "新闻资讯",
        },
        component: () => import("../views/newsInformation/newsInformation.vue"),
      },
      {
        name: "personnelRecruitment",
        path: "/personnelRecruitment",
        component: () =>
          import("../views/personnelRecruitment/personnelRecruitment.vue"),
        meta: {
          title: "人才招聘",
        },
      },
      {
        path: "/contactUs",
        name: "contactUs",
        meta: {
          title: "联系我们",
        },
        component: () => import("../views/home/index.vue"),
      },
      {
        path: "/newsDetail",
        name: "newsDetail",
        meta: {
          title: "新闻详情",
        },
        component: () =>
          import("../views/newsInformation/component/newsDetail.vue"),
      },
      {
        path: "/illnessDetail",
        name: "illnessDetail",
        meta: {
          title: "相关疾病或产品详情",
        },
        component: () =>
          import("../views/productIntroduction/component/illnessDetail.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
